"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PosthogEvent () {
        return PosthogEvent;
    },
    get PosthogGroup () {
        return PosthogGroup;
    },
    get PosthogPerson () {
        return PosthogPerson;
    },
    get PosthogProject () {
        return PosthogProject;
    },
    get PosthogSource () {
        return PosthogSource;
    },
    get PosthogSurveyWebhookPayload () {
        return PosthogSurveyWebhookPayload;
    },
    get PosthogWebhookResponse () {
        return PosthogWebhookResponse;
    }
});
const _zod = require("zod");
const PosthogEvent = _zod.z.object({
    uuid: _zod.z.string(),
    event: _zod.z.string(),
    distinct_id: _zod.z.string(),
    properties: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional(),
    timestamp: _zod.z.string(),
    url: _zod.z.string().optional()
});
const PosthogPerson = _zod.z.object({
    id: _zod.z.string(),
    name: _zod.z.string().optional(),
    url: _zod.z.string().optional(),
    properties: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional()
});
const PosthogGroup = _zod.z.object({
    id: _zod.z.string(),
    type: _zod.z.string(),
    index: _zod.z.number(),
    url: _zod.z.string().optional(),
    properties: _zod.z.record(_zod.z.string(), _zod.z.unknown()).optional()
});
const PosthogProject = _zod.z.object({
    id: _zod.z.number(),
    name: _zod.z.string(),
    url: _zod.z.string().optional()
});
const PosthogSource = _zod.z.object({
    name: _zod.z.string(),
    url: _zod.z.string().optional()
});
const PosthogSurveyWebhookPayload = _zod.z.object({
    event: PosthogEvent,
    person: PosthogPerson.optional(),
    groups: _zod.z.record(_zod.z.string(), PosthogGroup).optional(),
    project: PosthogProject.optional(),
    source: PosthogSource.optional()
});
const PosthogWebhookResponse = _zod.z.object({
    received: _zod.z.boolean()
});
